var te = Object.defineProperty;
var ie = (i, e, t) => e in i ? te(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var c = (i, e, t) => ie(i, typeof e != "symbol" ? e + "" : e, t);
const H = {
  LoadFail: 0,
  BadSignature: 1,
  BadTimestamp: 2,
  BadSettingValue: 3,
  BadFormat: 4,
  UnknownSetting: 5
};
class V extends Error {
  constructor(t) {
    super(t.reason);
    c(this, "code");
    c(this, "line");
    this.code = t.code, this.line = t.line;
  }
}
const G = /\r?\n|\r/gm;
class re {
  constructor(e) {
    c(this, "writable");
    c(this, "readable");
    const t = new se(e);
    this.writable = new WritableStream({
      write(r) {
        t.transform(r);
      },
      close() {
        t.close();
      }
    }), this.readable = new ReadableStream({
      start(r) {
        t.onLine = (n) => r.enqueue(n), t.onClose = () => r.close();
      }
    });
  }
}
class se {
  constructor(e) {
    c(this, "_buffer", "");
    c(this, "_decoder");
    c(this, "onLine");
    c(this, "onClose");
    this._decoder = new TextDecoder(e);
  }
  transform(e) {
    this._buffer += this._decoder.decode(e, { stream: !0 });
    const t = this._buffer.split(G);
    this._buffer = t.pop() || "";
    for (let r = 0; r < t.length; r++)
      this.onLine(t[r].trim());
  }
  close() {
    this._buffer && this.onLine(this._buffer.trim()), this._buffer = "", this.onClose();
  }
}
async function ne(i, e) {
  const t = new ReadableStream({
    start(r) {
      const n = i.split(G);
      for (const s of n)
        r.enqueue(s);
      r.close();
    }
  });
  return C(t, e);
}
async function C(i, e) {
  const t = (e == null ? void 0 : e.type) ?? "vtt";
  let r;
  if (typeof t == "string")
    switch (t) {
      case "srt":
        r = (await import("./srt-parser-HIGL5vQl.js")).default;
        break;
      case "ssa":
      case "ass":
        r = (await import("./ssa-parser-DsrjQpwb.js")).default;
        break;
      default:
        r = (await Promise.resolve().then(function() {
          return Se;
        })).default;
    }
  else
    r = t;
  let n;
  const s = i.getReader(), o = r(), a = (e == null ? void 0 : e.errors) !== !1 || !!(e != null && e.strict) || !!(e != null && e.errors);
  await o.init({
    strict: !1,
    ...e,
    errors: a,
    type: t,
    cancel() {
      s.cancel(), n = o.done(!0);
    }
  });
  let l = 1;
  for (; ; ) {
    const { value: h, done: f } = await s.read();
    if (f) {
      o.parse("", l), n = o.done(!1);
      break;
    }
    o.parse(h, l), l++;
  }
  return n;
}
async function ae(i, e) {
  var o, a, l;
  const t = await i;
  if (!t.ok || !t.body) {
    let h;
    return h = new V({
      code: H.LoadFail,
      reason: t.ok ? `response body is missing (status: ${t.status})` : `response is not ok (status: ${t.status})`,
      line: -1
    }), (o = e == null ? void 0 : e.onError) == null || o.call(e, h), {
      metadata: {},
      cues: [],
      regions: [],
      errors: [h]
    };
  }
  const r = t.headers.get("content-type") || "", n = (a = r.match(/text\/(.*?)(?:;|$)/)) == null ? void 0 : a[1], s = (l = r.match(/charset=(.*?)(?:;|$)/)) == null ? void 0 : l[1];
  return W(t.body, { type: n, encoding: s, ...e });
}
async function W(i, { encoding: e = "utf-8", ...t } = {}) {
  const r = i.pipeThrough(new re(e));
  return C(r, t);
}
class X extends EventTarget {
  constructor(t, r, n) {
    super();
    /**
     * A string that identifies the cue.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/TextTrackCue/id}
     */
    c(this, "id", "");
    /**
     * A `double` that represents the video time that the cue will start being displayed, in seconds.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/TextTrackCue/startTime}
     */
    c(this, "startTime");
    /**
     * A `double` that represents the video time that the cue will stop being displayed, in seconds.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/TextTrackCue/endTime}
     */
    c(this, "endTime");
    /**
     * Returns a string with the contents of the cue.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/text}
     */
    c(this, "text");
    /**
     * A `boolean` for whether the video will pause when this cue stops being displayed.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/TextTrackCue/pauseOnExit}
     */
    c(this, "pauseOnExit", !1);
    this.startTime = t, this.endTime = r, this.text = n;
  }
  addEventListener(t, r, n) {
    super.addEventListener(t, r, n);
  }
  removeEventListener(t, r, n) {
    super.removeEventListener(t, r, n);
  }
}
const N = typeof document > "u", oe = N ? X : window.VTTCue;
class F extends oe {
  constructor() {
    super(...arguments);
    /**
     * A `VTTRegion` object describing the video's sub-region that the cue will be drawn onto,
     * or `null` if none is assigned.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/region}
     */
    c(this, "region", null);
    /**
     * The cue writing direction.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/vertical}
     */
    c(this, "vertical", "");
    /**
     * Returns `true` if the `VTTCue.line` attribute is an integer number of lines or a percentage
     * of the video size.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/snapToLines}
     */
    c(this, "snapToLines", !0);
    /**
     * Returns the line positioning of the cue. This can be the string `'auto'` or a number whose
     * interpretation depends on the value of `VTTCue.snapToLines`.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/line}
     */
    c(this, "line", "auto");
    /**
     * Returns an enum representing the alignment of the `VTTCue.line`.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/lineAlign}
     */
    c(this, "lineAlign", "start");
    /**
     * Returns the indentation of the cue within the line. This can be the string `'auto'` or a
     * number representing the percentage of the `VTTCue.region`, or the video size if `VTTCue`.region`
     * is `null`.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/position}
     */
    c(this, "position", "auto");
    /**
     * Returns an enum representing the alignment of the cue. This is used to determine what
     * the `VTTCue.position` is anchored to. The default is `'auto'`.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/positionAlign}
     */
    c(this, "positionAlign", "auto");
    /**
     * Returns a double representing the size of the cue, as a percentage of the video size.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/size}
     */
    c(this, "size", 100);
    /**
     * Returns an enum representing the alignment of all the lines of text within the cue box.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/align}
     */
    c(this, "align", "center");
    /**
     * Additional styles associated with the cue.
     */
    c(this, "style");
  }
}
class j {
  constructor() {
    /**
     * A string that identifies the region.
     */
    c(this, "id", "");
    /**
     * A `double` representing the width of the region, as a percentage of the video.
     */
    c(this, "width", 100);
    /**
     * A `double` representing the height of the region, in number of lines.
     */
    c(this, "lines", 3);
    /**
     * A `double` representing the region anchor X offset, as a percentage of the region.
     */
    c(this, "regionAnchorX", 0);
    /**
     * A `double` representing the region anchor Y offset, as a percentage of the region.
     */
    c(this, "regionAnchorY", 100);
    /**
     * A `double` representing the viewport anchor X offset, as a percentage of the video.
     */
    c(this, "viewportAnchorX", 0);
    /**
     * A `double` representing the viewport anchor Y offset, as a percentage of the video.
     */
    c(this, "viewportAnchorY", 100);
    /**
     * An enum representing how adding new cues will move existing cues.
     */
    c(this, "scroll", "");
  }
}
const P = ",", le = "%";
function ce(i) {
  const e = parseInt(i, 10);
  return Number.isNaN(e) ? null : e;
}
function w(i) {
  const e = parseInt(i.replace(le, ""), 10);
  return !Number.isNaN(e) && e >= 0 && e <= 100 ? e : null;
}
function M(i) {
  if (!i.includes(P))
    return null;
  const [e, t] = i.split(P).map(w);
  return e !== null && t !== null ? [e, t] : null;
}
function he(i) {
  const e = parseFloat(i);
  return Number.isNaN(e) ? null : e;
}
const ue = "WEBVTT", z = ",", fe = "%", T = /[:=]/, de = /^[\s\t]*(region|vertical|line|position|size|align)[:=]/, _e = "NOTE", ge = "REGION", me = /^REGION:?[\s\t]+/, v = /[\s\t]+/, pe = "-->", Te = /[\s\t]*-->[\s\t]+/, be = /start|center|end|left|right/, ve = /start|center|end/, we = /line-(?:left|right)|center|auto/, ye = /^(?:(\d{1,2}):)?(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/;
var Y = /* @__PURE__ */ ((i) => (i[i.None = 0] = "None", i[i.Header = 1] = "Header", i[i.Cue = 2] = "Cue", i[i.Region = 3] = "Region", i[i.Note = 4] = "Note", i))(Y || {});
class q {
  constructor() {
    c(this, "_init");
    c(this, "_block", 0);
    c(this, "_metadata", {});
    c(this, "_regions", {});
    c(this, "_cues", []);
    c(this, "_cue", null);
    c(this, "_region", null);
    c(this, "_errors", []);
    c(this, "_errorBuilder");
    c(this, "_prevLine", "");
  }
  async init(e) {
    this._init = e, e.strict && (this._block = 1), e.errors && (this._errorBuilder = (await import("./errors-Bfk1GqFn.js")).ParseErrorBuilder);
  }
  parse(e, t) {
    var r, n, s, o, a, l;
    if (e === "")
      this._cue ? (this._cues.push(this._cue), (n = (r = this._init).onCue) == null || n.call(r, this._cue), this._cue = null) : this._region ? (this._regions[this._region.id] = this._region, (o = (s = this._init).onRegion) == null || o.call(s, this._region), this._region = null) : this._block === 1 && (this._parseHeader(e, t), (l = (a = this._init).onHeaderMetadata) == null || l.call(a, this._metadata)), this._block = 0;
    else if (this._block)
      switch (this._block) {
        case 1:
          this._parseHeader(e, t);
          break;
        case 2:
          if (this._cue) {
            const h = this._cue.text.length > 0;
            !h && de.test(e) ? this._parseCueSettings(e.split(v), t) : this._cue.text += (h ? `
` : "") + e;
          }
          break;
        case 3:
          this._parseRegionSettings(e.split(v), t);
          break;
      }
    else if (e.startsWith(_e))
      this._block = 4;
    else if (e.startsWith(ge))
      this._block = 3, this._region = new j(), this._parseRegionSettings(e.replace(me, "").split(v), t);
    else if (e.includes(pe)) {
      const h = this._parseTimestamp(e, t);
      h && (this._cue = new F(h[0], h[1], ""), this._cue.id = this._prevLine, this._parseCueSettings(h[2], t)), this._block = 2;
    } else t === 1 && this._parseHeader(e, t);
    this._prevLine = e;
  }
  done() {
    return {
      metadata: this._metadata,
      cues: this._cues,
      regions: Object.values(this._regions),
      errors: this._errors
    };
  }
  _parseHeader(e, t) {
    var r;
    if (t > 1) {
      if (T.test(e)) {
        const [n, s] = e.split(T);
        n && (this._metadata[n] = (s || "").replace(v, ""));
      }
    } else e.startsWith(ue) ? this._block = 1 : this._handleError((r = this._errorBuilder) == null ? void 0 : r._badVTTHeader());
  }
  _parseTimestamp(e, t) {
    var h, f, u;
    const [r, n = ""] = e.split(Te), [s, ...o] = n.split(v), a = E(r), l = E(s);
    if (a !== null && l !== null && l > a)
      return [a, l, o];
    a === null && this._handleError((h = this._errorBuilder) == null ? void 0 : h._badStartTimestamp(r, t)), l === null && this._handleError((f = this._errorBuilder) == null ? void 0 : f._badEndTimestamp(s, t)), a != null && l !== null && l > a && this._handleError((u = this._errorBuilder) == null ? void 0 : u._badRangeTimestamp(a, l, t));
  }
  /**
   * @see {@link https://www.w3.org/TR/webvtt1/#region-settings-parsing}
   */
  _parseRegionSettings(e, t) {
    var n, s;
    let r;
    for (let o = 0; o < e.length; o++)
      if (T.test(e[o])) {
        r = !1;
        const [a, l] = e[o].split(T);
        switch (a) {
          case "id":
            this._region.id = l;
            break;
          case "width":
            const h = w(l);
            h !== null ? this._region.width = h : r = !0;
            break;
          case "lines":
            const f = ce(l);
            f !== null ? this._region.lines = f : r = !0;
            break;
          case "regionanchor":
            const u = M(l);
            u !== null ? (this._region.regionAnchorX = u[0], this._region.regionAnchorY = u[1]) : r = !0;
            break;
          case "viewportanchor":
            const d = M(l);
            d !== null ? (this._region.viewportAnchorX = d[0], this._region.viewportAnchorY = d[1]) : r = !0;
            break;
          case "scroll":
            l === "up" ? this._region.scroll = "up" : r = !0;
            break;
          default:
            this._handleError((n = this._errorBuilder) == null ? void 0 : n._unknownRegionSetting(a, l, t));
        }
        r && this._handleError((s = this._errorBuilder) == null ? void 0 : s._badRegionSetting(a, l, t));
      }
  }
  /**
   * @see {@link https://www.w3.org/TR/webvtt1/#cue-timings-and-settings-parsing}
   */
  _parseCueSettings(e, t) {
    var n, s;
    let r;
    for (let o = 0; o < e.length; o++)
      if (r = !1, T.test(e[o])) {
        const [a, l] = e[o].split(T);
        switch (a) {
          case "region":
            const h = this._regions[l];
            h && (this._cue.region = h);
            break;
          case "vertical":
            l === "lr" || l === "rl" ? (this._cue.vertical = l, this._cue.region = null) : r = !0;
            break;
          case "line":
            const [f, u] = l.split(z);
            if (f.includes(fe)) {
              const b = w(f);
              b !== null ? (this._cue.line = b, this._cue.snapToLines = !1) : r = !0;
            } else {
              const b = he(f);
              b !== null ? this._cue.line = b : r = !0;
            }
            ve.test(u) ? this._cue.lineAlign = u : u && (r = !0), this._cue.line !== "auto" && (this._cue.region = null);
            break;
          case "position":
            const [d, g] = l.split(z), B = w(d);
            B !== null ? this._cue.position = B : r = !0, g && we.test(g) ? this._cue.positionAlign = g : g && (r = !0);
            break;
          case "size":
            const A = w(l);
            A !== null ? (this._cue.size = A, A < 100 && (this._cue.region = null)) : r = !0;
            break;
          case "align":
            be.test(l) ? this._cue.align = l : r = !0;
            break;
          default:
            this._handleError((n = this._errorBuilder) == null ? void 0 : n._unknownCueSetting(a, l, t));
        }
        r && this._handleError((s = this._errorBuilder) == null ? void 0 : s._badCueSetting(a, l, t));
      }
  }
  _handleError(e) {
    var t, r;
    if (e) {
      if (this._errors.push(e), this._init.strict)
        throw this._init.cancel(), e;
      (r = (t = this._init).onError) == null || r.call(t, e);
    }
  }
}
function E(i) {
  const e = i.match(ye);
  if (!e)
    return null;
  const t = e[1] ? parseInt(e[1], 10) : 0, r = parseInt(e[2], 10), n = parseInt(e[3], 10), s = e[4] ? parseInt(e[4].padEnd(3, "0"), 10) : 0, o = t * 3600 + r * 60 + n + s / 1e3;
  return t < 0 || r < 0 || n < 0 || s < 0 || r > 59 || n > 59 ? null : o;
}
function Ee() {
  return new q();
}
var Se = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  VTTBlock: Y,
  VTTParser: q,
  default: Ee,
  parseVTTTimestamp: E
});
const Re = /[0-9]/, Ae = /[\s\t]+/, D = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span",
  timestamp: "span"
}, ke = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&nbsp;": " ",
  "&lrm;": "‎",
  "&rlm;": "‏"
}, Ce = /&(?:amp|lt|gt|quot|#(0+)?39|nbsp|lrm|rlm);/g, Ne = /* @__PURE__ */ new Set([
  "white",
  "lime",
  "cyan",
  "red",
  "yellow",
  "magenta",
  "blue",
  "black"
]), Ie = /* @__PURE__ */ new Set(Object.keys(D));
function K(i) {
  var h, f;
  let e = "", t = 1, r = [], n = [], s;
  for (let u = 0; u < i.text.length; u++) {
    const d = i.text[u];
    switch (t) {
      case 1:
        d === "<" ? (l(), t = 2) : e += d;
        break;
      case 2:
        switch (d) {
          case `
`:
          case "	":
          case " ":
            o(), t = 4;
            break;
          case ".":
            o(), t = 3;
            break;
          case "/":
            t = 5;
            break;
          case ">":
            o(), t = 1;
            break;
          default:
            !e && Re.test(d) && (t = 6), e += d;
            break;
        }
        break;
      case 3:
        switch (d) {
          case "	":
          case " ":
          case `
`:
            a(), s && ((h = s.class) == null || h.trim()), t = 4;
            break;
          case ".":
            a();
            break;
          case ">":
            a(), s && ((f = s.class) == null || f.trim()), t = 1;
            break;
          default:
            e += d;
        }
        break;
      case 4:
        d === ">" ? (e = e.replace(Ae, " "), (s == null ? void 0 : s.type) === "v" ? s.voice = k(e) : (s == null ? void 0 : s.type) === "lang" && (s.lang = k(e)), e = "", t = 1) : e += d;
        break;
      case 5:
        d === ">" && (e = "", s = n.pop(), t = 1);
        break;
      case 6:
        if (d === ">") {
          const g = E(e);
          g !== null && g >= i.startTime && g <= i.endTime && (e = "timestamp", o(), s.time = g), e = "", t = 1;
        } else
          e += d;
        break;
    }
  }
  function o() {
    if (Ie.has(e)) {
      const u = s;
      s = Oe(e), u ? (n[n.length - 1] !== u && n.push(u), u.children.push(s)) : r.push(s);
    }
    e = "", t = 1;
  }
  function a() {
    if (s && e) {
      const u = e.replace("bg_", "");
      Ne.has(u) ? s[e.startsWith("bg_") ? "bgColor" : "color"] = u : s.class = s.class ? s.class + " " + e : e;
    }
    e = "";
  }
  function l() {
    if (!e)
      return;
    const u = { type: "text", data: k(e) };
    s ? s.children.push(u) : r.push(u), e = "";
  }
  return t === 1 && l(), r;
}
function Oe(i) {
  return {
    tagName: D[i],
    type: i,
    children: []
  };
}
function k(i) {
  return i.replace(Ce, (e) => ke[e] || "'");
}
function _(i, e, t) {
  i.style.setProperty(`--${e}`, t + "");
}
function m(i, e, t = !0) {
  i.setAttribute(`data-${e}`, t === !0 ? "" : t + "");
}
function S(i, e) {
  i.setAttribute("data-part", e);
}
function Le(i) {
  return parseFloat(getComputedStyle(i).lineHeight) || 0;
}
function xe(i) {
  if (N)
    throw Error(
      "[media-captions] called `createVTTCueTemplate` on the server - use `renderVTTCueString`"
    );
  const e = document.createElement("template");
  return e.innerHTML = I(i), { cue: i, content: e.content };
}
function I(i, e = 0) {
  return O(K(i), e);
}
function O(i, e = 0) {
  let t, r = "";
  for (const n of i)
    if (n.type === "text")
      r += n.data;
    else {
      const s = n.type === "timestamp";
      t = {}, t.class = n.class, t.title = n.type === "v" && n.voice, t.lang = n.type === "lang" && n.lang, t["data-part"] = n.type === "v" && "voice", s && (t["data-part"] = "timed", t["data-time"] = n.time, t["data-future"] = n.time > e, t["data-past"] = n.time < e), t.style = `${n.color ? `color: ${n.color};` : ""}${n.bgColor ? `background-color: ${n.bgColor};` : ""}`;
      const o = Object.entries(t).filter((a) => a[1]).map((a) => `${a[0]}="${a[1] === !0 ? "" : a[1]}"`).join(" ");
      r += `<${n.tagName}${o ? " " + o : ""}>${O(
        n.children
      )}</${n.tagName}>`;
    }
  return r;
}
function J(i, e) {
  if (!N)
    for (const t of i.querySelectorAll('[data-part="timed"]')) {
      const r = Number(t.getAttribute("data-time"));
      Number.isNaN(r) || (r > e ? m(t, "future") : t.removeAttribute("data-future"), r < e ? m(t, "past") : t.removeAttribute("data-past"));
    }
}
function Be(i, e) {
  let t = null, r;
  function n() {
    s(), i(...r), r = void 0;
  }
  function s() {
    clearTimeout(t), t = null;
  }
  function o() {
    r = [].slice.call(arguments), s(), t = setTimeout(n, e);
  }
  return o;
}
const p = Symbol("STARTING_BOX");
function L(i) {
  return i instanceof HTMLElement ? {
    top: i.offsetTop,
    width: i.clientWidth,
    height: i.clientHeight,
    left: i.offsetLeft,
    right: i.offsetLeft + i.clientWidth,
    bottom: i.offsetTop + i.clientHeight
  } : { ...i };
}
function R(i, e, t) {
  switch (e) {
    case "+x":
      i.left += t, i.right += t;
      break;
    case "-x":
      i.left -= t, i.right -= t;
      break;
    case "+y":
      i.top += t, i.bottom += t;
      break;
    case "-y":
      i.top -= t, i.bottom -= t;
      break;
  }
}
function Pe(i, e) {
  return i.left <= e.right && i.right >= e.left && i.top <= e.bottom && i.bottom >= e.top;
}
function Me(i, e) {
  for (let t = 0; t < e.length; t++)
    if (Pe(i, e[t]))
      return e[t];
  return null;
}
function $(i, e) {
  return e.top >= 0 && e.bottom <= i.height && e.left >= 0 && e.right <= i.width;
}
function ze(i, e, t) {
  switch (t) {
    case "+x":
      return e.left < 0;
    case "-x":
      return e.right > i.width;
    case "+y":
      return e.top < 0;
    case "-y":
      return e.bottom > i.height;
  }
}
function $e(i, e) {
  const t = Math.max(0, Math.min(i.width, e.right) - Math.max(0, e.left)), r = Math.max(0, Math.min(i.height, e.bottom) - Math.max(0, e.top));
  return t * r / (i.height * i.width);
}
function x(i, e) {
  return {
    top: e.top / i.height,
    left: e.left / i.width,
    right: (i.width - e.right) / i.width,
    bottom: (i.height - e.bottom) / i.height
  };
}
function Q(i, e) {
  return e.top = e.top * i.height, e.left = e.left * i.width, e.right = i.width - e.right * i.width, e.bottom = i.height - e.bottom * i.height, e;
}
const Z = ["top", "left", "right", "bottom"];
function U(i, e, t, r) {
  const n = x(e, t);
  for (const s of Z)
    _(i, `${r}-${s}`, n[s] * 100 + "%");
}
function ee(i, e, t, r) {
  let n = 1, s, o = { ...e };
  for (let a = 0; a < r.length; a++) {
    for (; ze(i, e, r[a]) || $(i, e) && Me(e, t); )
      R(e, r[a], 1);
    if ($(i, e))
      return e;
    const l = $e(i, e);
    n > l && (s = { ...e }, n = l), e = { ...o };
  }
  return s || o;
}
const y = Symbol("POSITION_OVERRIDE");
function He(i, e, t, r) {
  let n = t.firstElementChild, s = We(e), o, a = [];
  if (t[p] || (t[p] = Ve(i, t)), o = Q(i, { ...t[p] }), t[y])
    a = [t[y] === "top" ? "+y" : "-y", "+x", "-x"];
  else if (e.snapToLines) {
    let l;
    switch (e.vertical) {
      case "":
        a = ["+y", "-y"], l = "height";
        break;
      case "rl":
        a = ["+x", "-x"], l = "width";
        break;
      case "lr":
        a = ["-x", "+x"], l = "width";
        break;
    }
    let h = Le(n), f = h * Math.round(s), u = i[l] + h, d = a[0];
    Math.abs(f) > u && (f = f < 0 ? -1 : 1, f *= Math.ceil(u / h) * h), s < 0 && (f += e.vertical === "" ? i.height : i.width, a = a.reverse()), R(o, d, f);
  } else {
    const l = e.vertical === "", h = l ? "+y" : "+x", f = l ? o.height : o.width;
    R(
      o,
      h,
      (l ? i.height : i.width) * s / 100
    ), R(
      o,
      h,
      e.lineAlign === "center" ? f / 2 : e.lineAlign === "end" ? f : 0
    ), a = l ? ["-y", "+y", "-x", "+x"] : ["-x", "+x", "-y", "+y"];
  }
  return o = ee(i, o, r, a), U(t, i, o, "cue"), o;
}
function Ve(i, e) {
  const t = L(e), r = Ge(e);
  if (e[y] = !1, r.top && (t.top = r.top, t.bottom = r.top + t.height, e[y] = "top"), r.bottom) {
    const n = i.height - r.bottom;
    t.top = n - t.height, t.bottom = n, e[y] = "bottom";
  }
  return r.left && (t.left = r.left), r.right && (t.right = i.width - r.right), x(i, t);
}
function Ge(i) {
  const e = {};
  for (const t of Z)
    e[t] = parseFloat(i.style.getPropertyValue(`--cue-${t}`));
  return e;
}
function We(i) {
  return i.line === "auto" ? i.snapToLines ? -1 : 100 : i.line;
}
function Xe(i) {
  if (i.position === "auto")
    switch (i.align) {
      case "start":
      case "left":
        return 0;
      case "right":
      case "end":
        return 100;
      default:
        return 50;
    }
  return i.position;
}
function Fe(i, e) {
  if (i.positionAlign === "auto")
    switch (i.align) {
      case "start":
        return e === "ltr" ? "line-left" : "line-right";
      case "end":
        return e === "ltr" ? "line-right" : "line-left";
      case "center":
        return "center";
      default:
        return `line-${i.align}`;
    }
  return i.positionAlign;
}
const je = ["-y", "+y", "-x", "+x"];
function Ye(i, e, t, r) {
  let n = Array.from(t.querySelectorAll('[data-part="cue-display"]')), s = 0, o = Math.max(0, n.length - e.lines);
  for (let l = n.length - 1; l >= o; l--)
    s += n[l].offsetHeight;
  _(t, "region-height", s + "px"), t[p] || (t[p] = x(i, L(t)));
  let a = { ...t[p] };
  return a = Q(i, a), a.width = t.clientWidth, a.height = s, a.right = a.left + a.width, a.bottom = a.top + s, a = ee(i, a, r, je), U(t, i, a, "region"), a;
}
class qe {
  constructor(e, t) {
    c(this, "overlay");
    c(this, "_overlayBox");
    c(this, "_currentTime", 0);
    c(this, "_dir", "ltr");
    c(this, "_activeCues", []);
    c(this, "_isResizing", !1);
    c(this, "_resizeObserver");
    c(this, "_regions", /* @__PURE__ */ new Map());
    c(this, "_cues", /* @__PURE__ */ new Map());
    c(this, "_resize", Be(() => {
      this._isResizing = !1, this._updateOverlay();
      for (const e of this._regions.values())
        e[p] = null;
      for (const e of this._cues.values())
        e && (e[p] = null);
      this._render(!0);
    }, 50));
    this.overlay = e, this.dir = (t == null ? void 0 : t.dir) ?? "ltr", e.setAttribute("translate", "yes"), e.setAttribute("aria-live", "off"), e.setAttribute("aria-atomic", "true"), S(e, "captions"), this._updateOverlay(), this._resizeObserver = new ResizeObserver(this._resizing.bind(this)), this._resizeObserver.observe(e);
  }
  /* Text direction. */
  get dir() {
    return this._dir;
  }
  set dir(e) {
    this._dir = e, m(this.overlay, "dir", e);
  }
  get currentTime() {
    return this._currentTime;
  }
  set currentTime(e) {
    this._currentTime = e, this.update();
  }
  changeTrack({ regions: e, cues: t }) {
    this.reset(), this._buildRegions(e);
    for (const r of t)
      this._cues.set(r, null);
    this.update();
  }
  addCue(e) {
    this._cues.set(e, null), this.update();
  }
  removeCue(e) {
    this._cues.delete(e), this.update();
  }
  update(e = !1) {
    this._render(e);
  }
  reset() {
    this._cues.clear(), this._regions.clear(), this._activeCues = [], this.overlay.textContent = "";
  }
  destroy() {
    this.reset(), this._resizeObserver.disconnect();
  }
  _resizing() {
    this._isResizing = !0, this._resize();
  }
  _updateOverlay() {
    this._overlayBox = L(this.overlay), _(this.overlay, "overlay-width", this._overlayBox.width + "px"), _(this.overlay, "overlay-height", this._overlayBox.height + "px");
  }
  _render(e = !1) {
    if (!this._cues.size || this._isResizing)
      return;
    let t, r = [...this._cues.keys()].filter((s) => this._currentTime >= s.startTime && this._currentTime <= s.endTime).sort(
      (s, o) => s.startTime !== o.startTime ? s.startTime - o.startTime : s.endTime - o.endTime
    ), n = r.map((s) => s.region);
    for (let s = 0; s < this._activeCues.length; s++) {
      if (t = this._activeCues[s], r[s] === t)
        continue;
      if (t.region && !n.includes(t.region)) {
        const a = this._regions.get(t.region.id);
        a && (a.removeAttribute("data-active"), e = !0);
      }
      const o = this._cues.get(t);
      o && (o.remove(), e = !0);
    }
    for (let s = 0; s < r.length; s++) {
      t = r[s];
      let o = this._cues.get(t);
      o || this._cues.set(t, o = this._createCueElement(t));
      const a = this._hasRegion(t) && this._regions.get(t.region.id);
      a && !a.hasAttribute("data-active") && (requestAnimationFrame(() => m(a, "active")), e = !0), o.isConnected || ((a || this.overlay).append(o), e = !0);
    }
    if (e) {
      const s = [], o = /* @__PURE__ */ new Set();
      for (let a = r.length - 1; a >= 0; a--) {
        if (t = r[a], o.has(t.region || t))
          continue;
        const l = this._hasRegion(t), h = l ? this._regions.get(t.region.id) : this._cues.get(t);
        l ? s.push(Ye(this._overlayBox, t.region, h, s)) : s.push(He(this._overlayBox, t, h, s)), o.add(l ? t.region : t);
      }
    }
    J(this.overlay, this._currentTime), this._activeCues = r;
  }
  _buildRegions(e) {
    if (e)
      for (const t of e) {
        const r = this._createRegionElement(t);
        this._regions.set(t.id, r), this.overlay.append(r);
      }
  }
  _createRegionElement(e) {
    const t = document.createElement("div");
    return S(t, "region"), m(t, "id", e.id), m(t, "scroll", e.scroll), _(t, "region-width", e.width + "%"), _(t, "region-anchor-x", e.regionAnchorX), _(t, "region-anchor-y", e.regionAnchorY), _(t, "region-viewport-anchor-x", e.viewportAnchorX), _(t, "region-viewport-anchor-y", e.viewportAnchorY), _(t, "region-lines", e.lines), t;
  }
  _createCueElement(e) {
    var o;
    const t = document.createElement("div"), r = Xe(e), n = Fe(e, this._dir);
    if (S(t, "cue-display"), e.vertical !== "" && m(t, "vertical"), _(t, "cue-text-align", e.align), e.style)
      for (const a of Object.keys(e.style))
        t.style.setProperty(a, e.style[a]);
    if (this._hasRegion(e))
      _(
        t,
        "cue-offset",
        `${r - (n === "line-right" ? 100 : n === "center" ? 50 : 0)}%`
      );
    else if (_(
      t,
      "cue-writing-mode",
      e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl"
    ), !((o = e.style) != null && o["--cue-width"])) {
      let a = r;
      n === "line-left" ? a = 100 - r : n === "center" && r <= 50 ? a = r * 2 : n === "center" && r > 50 && (a = (100 - r) * 2);
      const l = e.size < a ? e.size : a;
      e.vertical === "" ? _(t, "cue-width", l + "%") : _(t, "cue-height", l + "%");
    }
    const s = document.createElement("div");
    return S(s, "cue"), e.id && m(s, "id", e.id), s.innerHTML = I(e), t.append(s), t;
  }
  _hasRegion(e) {
    return e.region && e.size === 100 && e.vertical === "" && e.line === "auto";
  }
}
const Ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CaptionsRenderer: qe,
  ParseError: V,
  ParseErrorCode: H,
  TextCue: X,
  VTTCue: F,
  VTTRegion: j,
  createVTTCueTemplate: xe,
  parseByteStream: W,
  parseResponse: ae,
  parseText: ne,
  parseTextStream: C,
  parseVTTTimestamp: E,
  renderVTTCueString: I,
  renderVTTTokensString: O,
  tokenizeVTTCue: K,
  updateTimedVTTCueNodes: J
}, Symbol.toStringTag, { value: "Module" }));
export {
  V as P,
  q as V,
  Y as a,
  F as b,
  H as c,
  Ke as d,
  E as p
};
